import { IResponse } from './../models/util';

import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IColorPalette,
  IColorPaletteDetail,
  IColorPaletteOptionPayload,
  IColorPalettePayload
} from '../models';

const baseUrl = '/api/color-palettes';

export const getColorPaletteList = async (filters?: {
  page?: number;
  perPage?: number | string;
  name?: string;
  sortBy?: string;
  sortDirection?: string;
}): Promise<IResponse<IColorPalette[]>> => {
  try {
    const { data } = await axios.get(`${baseUrl}`, { params: filters });

    return data;
  } catch (error: any) {
    logError(error, 'getColorPaletteList failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createColorPalette = async (payload: IColorPalettePayload) => {
  try {
    const result = await axios.post(`${baseUrl}`, payload);
    return result.data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          ...payload
        }
      },
      'createColorPalette failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const getColorPaletteDetails = async (
  colorPaletteId: string
): Promise<IColorPaletteDetail> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${colorPaletteId}`);

    return data;
  } catch (error: any) {
    logError(error, 'getColorPaletteDetails failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateColorPaletteDetails = async (
  colorPaletteId: string,
  payload: IColorPalettePayload
): Promise<void> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${colorPaletteId}`, payload);

    return data;
  } catch (error: any) {
    logError(error, 'updateColorPaletteDetails failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteColorPaletteDetails = async (colorPaletteId: string): Promise<void> => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${colorPaletteId}`);

    return data;
  } catch (error: any) {
    logError(error, 'deleteColorPaletteDetails failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createColorPaletteOptions = async (
  colorPaletteId: string,
  payload: IColorPaletteOptionPayload
) => {
  try {
    const result = await axios.post(`${baseUrl}/${colorPaletteId}/options`, payload);
    return result.data;
  } catch (error) {
    logError(
      {
        error,
        payload: {
          ...payload
        }
      },
      'createColorPaletteOptions failed'
    );
    return Promise.reject(error?.response?.data);
  }
};

export const updateColorPaletteOptions = async (
  colorPaletteId: string,
  payload: IColorPalettePayload
): Promise<void> => {
  try {
    const { data } = await axios.put(`${baseUrl}/options/${colorPaletteId}`, payload);

    return data;
  } catch (error: any) {
    logError(error, 'updateColorPaletteOptions failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteColorPaletteOptions = async (colorPaletteId: string): Promise<void> => {
  try {
    const { data } = await axios.delete(`${baseUrl}/options/${colorPaletteId}`);

    return data;
  } catch (error: any) {
    logError(error, 'deleteColorPaletteOptions failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateColorPaletteOptionFile = async (
  colorPaletteId: string | number,
  imagePost: FormData
): Promise<string[]> => {
  try {
    const { data } = await axios.put(`${baseUrl}/options/${colorPaletteId}/file`, imagePost);
    return data;
  } catch (error: any) {
    logError(error, 'createPunchlistItemFiles failed');
    return Promise.reject(error?.response?.data);
  }
};
